var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PanelRow", { staticClass: "deviceview" }, [
    _c("div", { staticClass: "panel compact" }, [
      _c("header", { staticClass: "center" }, [
        _c("h4", [
          _vm._v(_vm._s(_vm._f("trans")("feelgrid:puredata.single_device")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "controls" },
        [
          _c("div", { staticClass: "input-group" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm._f("trans")("feelgrid:devices.select.label_one"))
              )
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.device_id,
                    expression: "device_id"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.device_id = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              _vm._l(_vm.available_devices, function(device) {
                return _c("option", { domProps: { value: device.id } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("text")(device.name)) +
                      "\n          "
                  )
                ])
              })
            )
          ]),
          _vm._v(" "),
          _c("IntervalSelector", {
            on: { reload: _vm.reload },
            model: {
              value: _vm.time_interval,
              callback: function($$v) {
                _vm.time_interval = $$v
              },
              expression: "time_interval"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.device
        ? _c(
            "div",
            { staticClass: "data-table" },
            [
              _c(
                "div",
                { staticClass: "list-holder scrollable-table" },
                [
                  _vm.list
                    ? _c("table", { staticClass: "itemstable" }, [
                        _c("thead", [
                          _c(
                            "tr",
                            [
                              _c("th", { staticClass: "time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "feelgrid:devices.data.fields.created_at"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.data_types.list, function(type) {
                                return _c("th", { staticClass: "type" }, [
                                  _vm._v(_vm._s(_vm._f("text")(type.title)))
                                ])
                              }),
                              _vm._v(" "),
                              _c("th", { staticClass: "padder" })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.list.list, function(point) {
                            return _c(
                              "tr",
                              [
                                _c(
                                  "td",
                                  { staticClass: "time" },
                                  [
                                    _c("Cell", {
                                      attrs: {
                                        field: { format: "datetime" },
                                        item: point.created_at
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.data_types.list, function(type) {
                                  return _c(
                                    "td",
                                    { staticClass: "value type" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("text")(
                                              _vm.datapoint(point, type)
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c("td", { staticClass: "padder" })
                              ],
                              2
                            )
                          })
                        )
                      ])
                    : _c("Loading")
                ],
                1
              ),
              _vm._v(" "),
              _c("Pages", {
                staticClass: "center",
                attrs: { pages: _vm.pages },
                model: {
                  value: _vm.p,
                  callback: function($$v) {
                    _vm.p = $$v
                  },
                  expression: "p"
                }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02767871", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02767871","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/feelgrid/modules/pureData/DeviceView.vue
// module id = null
// module chunks = 